import { render, staticRenderFns } from "./evaluatorsEdition.vue?vue&type=template&id=4641b636"
import script from "./evaluatorsEdition.vue?vue&type=script&lang=js"
export * from "./evaluatorsEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports